import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Database,
  SignOut,
  Plus,
  CaretDown,
  GearSix,
  ShoppingCartSimple,
  List,
  Check,
  DeviceMobile,
} from "@phosphor-icons/react";

export function DashboardHeader({ user, isAdmin, canOpenSettings, carts, activeCart, onActivateCart, onNewCart, onLogout, onNavigate, hideCart = false }) {
  return (
    <header className="flex items-center justify-between border-b border-zinc-300 px-4 py-3 lg:px-6">
      <div className="flex items-center gap-2">
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-sm border border-zinc-300 bg-zinc-50">
          <Database size={16} weight="bold" className="text-blue-600" />
        </div>
        <div>
          <h1 className="font-heading text-base font-bold tracking-tight text-zinc-950 sm:text-lg">
            BetterHome Inventory
          </h1>
          <p className="hidden text-[10px] uppercase tracking-[0.05em] text-zinc-400 sm:block">Main Products</p>
        </div>
      </div>
      <div className="flex items-center gap-2 sm:gap-3">
        <span className="hidden text-xs text-zinc-500 md:block" data-testid="current-user-email">
          {user?.email}
        </span>
        {!hideCart && (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" size="sm" className="relative rounded-sm border-zinc-300" data-testid="cart-selector-button">
                <ShoppingCartSimple size={14} className="sm:mr-1.5" />
                <span className="hidden max-w-[90px] truncate sm:inline">
                  {activeCart ? activeCart.customer_name : "Cart"}
                </span>
                <CaretDown size={10} className="hidden sm:ml-1.5 sm:inline" />
                {activeCart?.item_count > 0 && (
                  <span
                    className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full bg-blue-600 text-[10px] font-semibold text-white"
                    data-testid="cart-count-badge"
                  >
                    {activeCart.item_count}
                  </span>
                )}
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56" data-testid="cart-selector-menu">
              <div className="px-2 py-1.5 text-xs uppercase tracking-[0.05em] text-zinc-400">Switch Quote (latest 10)</div>
              {carts.slice(0, 10).map((c) => (
                <DropdownMenuItem
                  key={c.id}
                  onClick={() => onActivateCart(c.id)}
                  className="flex items-center gap-2"
                  data-testid={`cart-menu-item-${c.id}`}
                >
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    {c.is_active && <Check size={12} weight="bold" className="text-blue-600" />}
                  </span>
                  <span className="flex-1 truncate">{c.customer_name}</span>
                  <span className="text-xs text-zinc-400">{c.item_count}</span>
                </DropdownMenuItem>
              ))}
              <DropdownMenuItem onClick={onNewCart} data-testid="cart-menu-new-cart-item">
                <Plus size={14} className="mr-2" /> New Quote
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => onNavigate("/cart")} data-testid="cart-menu-view-cart-item">
                <List size={14} className="mr-2" /> All Quotes
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        )}
        <div className="hidden items-center gap-3 sm:flex">
          <Button
            variant="outline"
            size="sm"
            className="rounded-sm border-zinc-300"
            onClick={() => onNavigate("/mobile")}
            data-testid="mobile-lookup-view-button"
          >
            <DeviceMobile size={14} className="mr-1.5" /> Mobile Lookup
          </Button>
          {(canOpenSettings ?? isAdmin) && (
            <Button
              variant="outline"
              size="sm"
              className="rounded-sm border-zinc-300"
              onClick={() => onNavigate("/settings")}
              data-testid="settings-button"
            >
              <GearSix size={14} className="mr-1.5" /> Settings
            </Button>
          )}
          <Button variant="outline" size="sm" className="rounded-sm border-zinc-300" onClick={onLogout} data-testid="logout-button">
            <SignOut size={14} className="mr-1.5" /> Logout
          </Button>
        </div>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" size="sm" className="rounded-sm border-zinc-300 sm:hidden" data-testid="mobile-nav-menu-button">
              <List size={16} />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" data-testid="mobile-nav-menu-content">
            <div className="px-2 py-1.5 text-xs text-zinc-500">{user?.email}</div>
            <DropdownMenuItem onClick={() => onNavigate("/mobile")} data-testid="mobile-nav-lookup-item">
              <DeviceMobile size={14} className="mr-2" /> Mobile Lookup
            </DropdownMenuItem>
            {(canOpenSettings ?? isAdmin) && (
              <DropdownMenuItem onClick={() => onNavigate("/settings")} data-testid="mobile-settings-item">
                <GearSix size={14} className="mr-2" /> Settings
              </DropdownMenuItem>
            )}
            <DropdownMenuItem onClick={onLogout} data-testid="mobile-logout-item">
              <SignOut size={14} className="mr-2" /> Logout
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
